import React from 'react';
import { connect } from 'react-redux';
import {  makeJSONLD} from './JSONLDScript';
import { Input } from 'antd';

const { TextArea } = Input;

/**
 * Диалог, для отображения и копирования содержимого скрипта JSON+LD
 */
class JSONLDScriptDialog extends React.Component {
  
  render(){
    console.log(this);
    const url =  window.location.protocol+'//'+window.location.host+window.location.pathname+"#/adms/"+this.props.card.iri;
    const json = makeJSONLD(this.props.catalog, this.props.card, this.props.lang);
    const jsonPretty = '<script type="application/ld+json">\n'+JSON.stringify(JSON.parse(json),null,2)+'\n</script>';  
    return (
      <div>
        <TextArea rows={10} defaultValue={jsonPretty}></TextArea>
        <span>Проверить микроразметку в интерфейсе проверки расширенных результатов Google Поиска можно по <a href={"https://search.google.com/test/rich-results?url="+encodeURIComponent(url)} target="_blank">ссылке </a>. 
        <br /><i>Внимание! Доступ к карточке должен быть предоставлен анонимному пользователю.</i></span>
      </div>
    )
  }
}

function mapStateToProps(state, props) {
  //Значения в store redux
  const {vadms, vasset, vset } = state;
  const {lang, triplet} = props;
  return {
    lang: (lang)?lang: vset.lang,
    catalog: { state: vadms.state, ...vadms.catalog},
    card: vasset
  };
}

export default connect(mapStateToProps)(JSONLDScriptDialog);